import React, { Component } from 'react';
import LookupAdminItem from '../../../../Domain/LookupAdminItem';
import LookupItemService from '../../../../Services/LookupItemService';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../../Elements/ButtonRow';
import LookupPanelDescription from './LookupPanelDescription';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import LookupSearchParams from '../LookupSearchParams.js';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';

class LookupItemAdmin extends Component
{
  constructor (props)
  {
    super(props);
    this.state = {
      itemList: [],
      selectedItem: null,
      searchItem: {},
    };

    LookupAdminItem.EditLookupAdminItemFunction = (id, item, itemList) => this.editFunction(id, item, itemList);
  }

  componentDidMount ()
  {
    LookupPanelDescription.loadCostGroupOptions();
  }

  editFunction (id, item)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selectedItem: item,
      searchItem: {},
    });
  }

  refresh ()
  {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  clickOnCancel ()
  {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  renderPanels ()
  {
    switch (this.state.shownPanel)
    {
      case ShownPanelsEnum.AddNewItem:
        const tempEdited = new LookupAdminItem();
        tempEdited.LookupId = this.props.LookupItemId;
        tempEdited.LookupItemId = 0;
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={tempEdited}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnSave={() => this.clickOnCancel()}
            windowDescription={LookupPanelDescription}
            errorCode='LIA53'
          />
        );
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnSave={() => this.clickOnCancel()}
            windowDescription={LookupPanelDescription}
            errorCode='LIA63'
          />
        );
      default:
        break;
    }
  }

  showPanel (key)
  {
    if (key === ShownPanelsEnum.Refresh)
    {
      this.refresh();
      key = ShownPanelsEnum.None;
    }
    if (key === this.state.shownPanel) key = ShownPanelsEnum.None;
    this.setState({ shownPanel: key });
  }

  RenderButtonRow ()
  {
    return (
      <ButtonRow
        colors={[ ButtonColorsEnum.Primary ]}
        labels={[ '' ]}
        keys={[ ShownPanelsEnum.AddNewItem ]}
        icons={[ 'fa fa-plus-circle' ]}
        roles={[ 'Admin' ]}
        onClick={this.showPanel.bind(this)}
        value={this.state.shownPanel}
        className='InnerMenuButtonFigmaList'
      />
    );
  }

  render ()
  {
    return (
      <div>
        {this.renderPanels()}
        {this.RenderButtonRow()}
        <TabOfDataTable
          type={LookupAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) =>
            LookupItemService.GetLookupItemListById(this.props.LookupItemId, orderById, orderDir)
          }
          convertDBItemsFunction={LookupItemService.ConvertDBLookupAdminItem}
          searchItem={this.state.searchItem}
          orderById={'Value'}
          orderDirection={OrderDirectionsEnum.Ascending}
          showSearchStrip={true}
          searchParamsType={LookupSearchParams}
          errorCode='LIA115'
        />
      </div>
    );
  }
}

export default LookupItemAdmin;
